<template>
    <div class="navbar-wrapper">
        <div class="nav-bar" :class="{'home-style':curPath === '/home'}">
            <div class="logo" @click="toPage('home')"><img src="../assets/logog.png" alt=""></div>
            <div class="nav-item-group">
                <!-- <div class="nav-item" @click="toPage('socialmedia')" :class="{'active':curPath === '/socialmedia'}">社 群</div>
                <div class="nav-item" @click="toPage('video')" :class="{'active':curPath === '/video'}">影 片</div>
                <div class="nav-item" @click="toPage('shop')" :class="{'active':curPath === '/shop'}">購 物</div> -->
                <div class="nav-item" @click="toPage('/exchange')" :class="{'active':curPath === '/exchange'}">交 換</div>
                <div class="nav-item" @click="toPage('/together')" :class="{'active':curPath === '/together'}">湊 團</div>
            </div>
            <div class="user-btn-group" >
                <div class="btn add" :class="{'active':showAddSelection}" @mouseover="toggleAddSelection(true)" @mouseleave="toggleAddSelection(false)">
                    <img src="../assets/icon/add.svg" alt="">
                    <div class="add-selection-container" v-if="showAddSelection">
                        <div class="add-selection" >
                            <div class="selection" @click="openAddExchange()">新增交換</div>
                            <div class="selection" @click="openAddTogether()">新增揪團</div>
                        </div>
                    </div>
                    
                </div>
                <div class="btn message" v-if="isLogin" @click="toPage('/notification')">
                <el-badge :value="notificationCount" :max="99" class="item" :hidden="notificationCount<1">
                    <i class="el-icon-bell"></i>
                </el-badge>
                </div>
                <div class="btn user" @mouseover="toggleUserSelection(true)" @mouseleave="toggleUserSelection(false)">
                    <img v-if="!isLogin" src="../assets/icon/user.svg" alt="" @click="toMyPage()">
                    <img v-else :src="userImg" alt="">
                    <div class="add-selection-container" v-if="showUserSelection">
                        <div class="add-selection">
                            <div class="selection" @click="toPage('/mine/profile')">個人檔案</div>
                            <div class="selection" @click="toPage('/mine/items')">我的物品</div>
                            <div class="selection" @click="logout()">登出</div>
                        </div>
                    </div>
                    
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import { mapState,mapActions } from 'vuex'
export default {
    data(){
        return {
            showAddSelection: false,
            showUserSelection: false,
        }
    },
    computed:{
        ...mapState({
            userImg: state => state.user.userImg,
            userName: state => state.user.userName,
            notificationCount: state => state.user.notificationCount,
        }),
        curPath(){
            return this.$route.path
        },
        isLogin(){
            return this.$store.state.user.userName?true:false
        }
    },
    methods:{
        toPage(path){
            this.$router.push(path)
            this.showAddSelection = false
        },
        toMyPage(){
            this.showAddSelection = false
            if (this.isLogin){
                this.toPage('/mine')
            } else {
                this.$showLoginPopup()
            }
        },
        toggleAddSelection(val){
            this.showAddSelection = val
        },
        toggleUserSelection(val){
             if (this.isLogin){
                this.showUserSelection = val
            } else {
               return 
            }
            
        },
        openAddExchange(){
            if (this.isLogin){
                this.$store.commit('user/openAddExchange')
            } else {
                this.$showLoginPopup()
            }
            
        },
        openAddTogether(){
            if (this.isLogin){
                this.$store.commit('user/openAddTogether')
            } else {
                this.$showLoginPopup()
            }
        },
        logout(){
            localStorage.removeItem("userName")
            window.location.reload()
        }
    }

}
</script>

<style lang="scss" scoped>
.navbar-wrapper{
    width: 100%;
    z-index: 999;
    display: flex;
    height: 150px;
    background-color: #fff;
    .nav-bar {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 24px;
        font-weight: lighter;
        .logo{
            width: 100px;
            img {
                width: 100%;
            }
        }
        .nav-item-group{
            display: flex;
            .nav-item{
                cursor: pointer;
                padding: 0 15px;
                position: relative;
                &::after {
                    content: "";
                    display: block;
                    position: absolute;
                    bottom: -10px;
                    left: 50%;
                    transform: translateX(-50%);
                    height: 2px;
                    width: 0;
                    background-color:$mainColor;
                }
                &:hover{
                    &::after {
                        width: 50%;
                        transition:  0.5s;
                    }
                }
                &.active {
                    &::after {
                        width: 50%;
                    }
                }
            }
        }
        .user-btn-group{
            display: flex;
            align-items: center;
            .btn {
                margin: 0 5px;
                width: 24px;
                height: 24px;
                position: relative;
                padding: 5px;
                cursor: pointer;
                img {
                    width: 100%;
                }
            }
            .user {
                border-radius: 12px;
            }
            .add {
                &.active {
                    border-radius: 10px;
                    box-shadow: 0 0 10px #ccc;
                }
            }
            .add-selection-container {
                position: absolute;
                top: 30px;
                right: 0;
                width: 110px;
                font-size: 14px;
                padding: 10px 0;
                z-index: 2;
                .add-selection{
                    padding: 10px 0 ;
                    box-shadow: 0 0 10px #ccc;
                    
                    background-color: #fff;
                    border-radius: 10px;
                    box-sizing: border-box;
                }
                .delete {
                    cursor: pointer;
                }
                .selection{
                    height: 30px;
                    line-height:30px;
                    text-align: center;
                    &:hover{
                        background-color: $mainColor;
                        cursor: pointer;
                    }
                }
            }
            .logout{
                font-size: 12px;
                line-height: 24px;
                cursor: pointer;
                &:hover {
                    border-radius: 10px;
                    box-shadow: 0 0 10px #ccc;
                }
            }
        }
    }

}

</style>